import type { Customer } from '../types'
import { maskCep, maskCnpj, maskCpf, maskPhone } from './masks'

const FIRST_NAMES = [
  'Eduardo',
  'Ana',
  'Bruno',
  'Carla',
  'Diego',
  'Fernanda',
  'Gustavo',
  'Helena',
  'Igor',
  'Juliana',
  'Lucas',
  'Mariana',
  'Nicolas',
  'Olivia',
  'Paulo',
]
const LAST_NAMES = [
  'Predebon',
  'Silva',
  'Souza',
  'Oliveira',
  'Santos',
  'Lima',
  'Costa',
  'Rocha',
  'Almeida',
  'Ferreira',
]
const COMPANIES = [
  'Tech Norte',
  'Byte Sul',
  'Master Soft',
  'InfoPrime',
  'CloudBR',
  'NetLab',
  null,
]
const CITIES = [
  { cidade: 'Chapecó', estado: 'SC' },
  { cidade: 'Florianópolis', estado: 'SC' },
  { cidade: 'Curitiba', estado: 'PR' },
  { cidade: 'Porto Alegre', estado: 'RS' },
  { cidade: 'São Paulo', estado: 'SP' },
  { cidade: 'Joinville', estado: 'SC' },
]

/** Deterministic mock CPF (valid checksum). */
function makeCpf(seed: number): string {
  const base = String(100000000 + seed).slice(0, 9)
  const d1 = cpfDigit(base, 10)
  const d2 = cpfDigit(base + d1, 11)
  return maskCpf(base + d1 + d2)
}

function cpfDigit(base: string, factor: number): string {
  let total = 0
  for (let i = 0; i < base.length; i++) total += Number(base[i]) * (factor - i)
  const rest = (total * 10) % 11
  return String(rest === 10 ? 0 : rest)
}

function makeCnpj(seed: number): string {
  const base = String(100000000000 + seed).slice(0, 12)
  const w1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  const w2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  const d1 = cnpjDigit(base, w1)
  const d2 = cnpjDigit(base + d1, w2)
  return maskCnpj(base + d1 + d2)
}

function cnpjDigit(base: string, weights: number[]): string {
  const total = base.split('').reduce((sum, d, i) => sum + Number(d) * weights[i]!, 0)
  const rest = total % 11
  return String(rest < 2 ? 0 : 11 - rest)
}

export function createFakeCustomers(total = 30): Customer[] {
  const now = Date.UTC(2026, 0, 15)
  const list: Customer[] = []

  for (let i = 0; i < total; i++) {
    const isPj = i % 3 === 0
    const first = FIRST_NAMES[i % FIRST_NAMES.length]!
    const last = LAST_NAMES[i % LAST_NAMES.length]!
    const loc = CITIES[i % CITIES.length]!
    const company = isPj ? COMPANIES[i % COMPANIES.length] ?? `Empresa ${i + 1}` : null
    const created = new Date(now - i * 86_400_000).toISOString()

    list.push({
      id: `cust-${String(i + 1).padStart(3, '0')}`,
      tipoPessoa: isPj ? 'PJ' : 'PF',
      nome: `${first} ${last}`,
      empresa: company,
      cpfCnpj: isPj ? makeCnpj(i + 11) : makeCpf(i + 21),
      inscricaoEstadual: isPj ? `ISENTO` : null,
      telefone: maskPhone(`49${900000000 + i}`),
      whatsapp: maskPhone(`49${980000000 + i}`),
      email: `${first.toLowerCase()}.${last.toLowerCase()}${i}@email.com`,
      cep: maskCep(`8980${String(1000 + i).slice(0, 4)}`),
      logradouro: `Rua das Palmeiras`,
      numero: String(100 + i),
      bairro: i % 2 === 0 ? 'Centro' : 'Efapi',
      cidade: loc.cidade,
      estado: loc.estado,
      observacoes: i % 5 === 0 ? 'Cliente prioritário Master Informática.' : null,
      ativo: i % 7 !== 0,
      createdAt: created,
      updatedAt: created,
    })
  }

  return list
}
